const rolesIds = Object.freeze({
  Especialista: 'C0D81E19-8EB9-428C-9E56-66479BF5B34B',
  EspecialistaRP: '2843DB69-3643-4151-B62D-96405C105D91',
  ProveedorRP: '00F9EC05-D0C9-4E80-8244-2175A930E909',
  Proveedor: '0A639AE7-0F2A-49F0-B0B3-770C94B98663',
  AdminIL: '76129F36-5321-47B8-AE07-E5ADEE3417DF',
  Administrador: 'D3FE481E-4BA7-4CBB-8A59-D7BE75DEAA13',
  AdminProvider: '146FBE30-F427-4906-96EC-13F27A9CF3D5',
  AdminSAEE: '756DC9D0-9619-41B8-A158-E3E7A838C468',
  AdministradorRP: '17AE9A09-4939-4C75-9739-DD12DF782DE2',
  UMESRAdmin: '6A45B3F1-EE61-4325-9902-6B0CE87C2373',
  MaestroPrivado: 'E8EFDB5A-E72A-4DDD-859D-15CDE4E3A196',
  MaestroVerano: 'E612F882-C128-45D1-8606-5A57FEF47F24',
  Maestro: 'E879E31C-7046-416E-9405-9B8CCBF1A06C',
  MaestroRegular: '433EC539-144D-40B2-80E5-F6415672E749',
  MaestroIngles: '1D0E9665-28E0-45AF-A34F-9862B069D152',
  MaestroItinerante: 'E172AC6C-A518-4443-83A0-AC3ED9A7BE90',
  MaestroTransitorio: '534A5D35-7E26-4A79-A9E0-AD230F75DCBF',
  MaestroJornadaParcial: '5EC0B184-4267-41F8-AD37-1DFE79C9B53C',
  Director: 'CC6325AA-8B93-40BA-BAC0-900B5EA038E9',
  AdministradorRFP: 'DC720A1C-DD64-454F-9128-FA2E59E9E7B2',
  ApoyoRFP: '5485555A-3176-4FF3-A3CB-5A87D400079A',
  CaatRequirente: '83E75C5A-E06A-433E-9E2C-54AFEBD81424',
  CAATTechnician: '8DBB7289-D2CE-4E3B-8EBF-55A2C6466CBC',
  ProviderPagoDirecto: '23D8804D-719C-420D-85F0-FAD2991BEBBF',
  AsistenteProviderPagoDirecto: '175F807D-5088-4D41-AF1D-A2D7A235556E',
  PadreExterno: 'EC4FDA3A-FC3C-4F55-90EA-CCEE388F674B',
  AbogadoRepresentante: 'EDC59D5F-F2DF-4B8C-F392-08D58F3470F5',
  AbogadoDLEE: '277298C0-8F4E-4C3E-F397-08D58F3470F5',
  JuezAdministrativo: 'A03BE06F-C667-40CD-F39A-08D58F3470F5',
  JuezCoordinador: 'EB87C8B8-5A01-4507-F399-08D58F3470F5',
  Mediator: 'BD76A536-CBAF-4D3C-F39B-08D58F3470F5',
  Conciliador: '4F68197F-3D98-4F44-F39C-08D58F3470F5',
  Investigador: 'D8AEF91E-CC8D-49B2-F39D-08D58F3470F5',
  EspecialistaInvestigaciónEE:'B168642E-D915-46B2-AE19-A72AE2401CE1',
  PadreEncargado:'B4D62638-1617-4826-9F6F-F7EC3138C41A',
});

export default rolesIds;
